const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Válasszon itt.",
  seeAll: "Összes megtekintése",
  clear: "Törlés",
  back: "Vissza",
  save: "Mentés",
  close: "Bezárás",
  of: "-ból/-ből",
  to: "-ig",
  copyrights: "© {date} Bridgestone Solutions. Minden jog fenntartva.",
  pageNotFound: "Az oldal nem található",
  accessDenied: "Hozzáférés megtagadva",
  search: "Keresés",
  year: "Év",
  buttons: {
    loading: "Betöltés...",
    export: "Exportálás",
    delete: "Törlés",
    save: "Mentés",
    cancel: "Mégse",
    next: "Következő",
    back: "Vissza",
    skip: "Átugrás",
    send: "Küldés",
    readNow: "Olvass most",
    pointsList: "Pontlista",
    clear: "Törlés",
    more: "Több",
    close: "Bezárás",
    reportError: "Hiba bejelentése",
    accept: "Elfogadás",
    download: "Letöltés",
    downloadAll: "Összes letöltése",
    selectAll: "Összes kijelölése",
    deselectAll: "Kijelölés megszüntetése",
    downloadSelection: "Kijelöltek letöltése",
    dealerInfoDownload: "Letöltés",
    toTheBasket: "Kosárba",
    toOrderDelivery: "Folytatás a szállítási címhez",
    discover: "Felfedezés",
    newAddress: "Új szállítási cím létrehozása",
    selectAddressBtn: "Szállítási cím kiválasztása",
    toOrderSummary: "Rendelés áttekintéséhez",
    placeOrder: "Kötelező érvényű rendelés",
    toDashboard: "Kezdőlapra",
    newOrder: "Új rendelés",
    userOrders: "A rendeléseidhez",
    toSearch: "Keresés",
    select: "Kiválasztás",
    moreCustomerNumbers: "+ TOVÁBBI ÜGYFÉLSZÁMOK HOZZÁADÁSA",
    loadMore: "Továbbiak betöltése",
    toStaffDashboard: "Irányítópulthoz",
    toQuiz: "Kvízhez",
    vouchers: "Utalványok",
    exchangeVoucher: "Utalványkód beváltása",
    confirm: "Megerősítés",
    sharePoints: "Pontok megosztása",
    create: "Létrehoz",
    update: "Frissítés",
    toBDrive: "B-Drive-ra",
    preview: "Előnézet",
    clickHere: "Részletek megtekintése",
    setFilters: "Kérjük, állítson be <b>oszloponként legfeljebb egy szűrőt</b>",
    all: "Összes",
  },
  tooltips: {
    info: "Segítségre van szüksége? +36 30 548 10 40",
  },
  confirmation: {
    header: "Megerősítés szükséges",
    message: "Biztosan törölni szeretné ezt a bejegyzést?",
  },
  nav: {
    consents: "Hozzájárulások",
    dashboard: "Kezdőlap",
    accountDashboard: "Irányítópult",
    account: "Profilom",
    mailbox: "Bejövő üzenetek",
    singleMailbox: "Üzenetek",
    stammdaten: "PROFILOM",
    news_feeds: "Hír",
    pointsOverview: "Pontok áttekintése",
    rewardsOverview: "Pontok áttekintése",
    about: "A BS Plus-ról",
    service_number: "Kapcsolat szervizzel",
    shop: "Jutalombolt",
    salesPromotions: "Értékesítési promóciók",
    promotions: "Fiókom",
    shopCategory: "Jutalomáruház",
    productDetails: "Termék részletei",
    userOrders: "Felhasználói rendelések",
    shoppingCart: "Bevásárlókosár",
    orderDelivery: "Szállítási cím",
    orderSummary: "Rendelés áttekintése",
    orderComplete: "Rendelés befejezve",
    text_page: "Statikus oldal",
    staff: "Szerviz irányítópult",
    onlineTrainings: "Online képzések",
    trainings: "Képzések",
    training: "Képzés",
    trainingForm: "Képzési űrlap",
    staffVouchers: "Utalványok",
    wholesalerVouchers: "Utalványok",
    brochure_prices: "Árlisták és brosúrák",
    investment: "Beruhazasi tamogatas",
    media: "Média",
    medias: "Média",
    contact_service: "Kapcsolat és szolgáltatás",
    productInfo: "TERMÉKINFORMÁCIÓK",
    bDrive: "Termékképek",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Részvételi feltételek",
    first_stop: "Bridgestone gumiabroncs-garancia",
    payouts: "Payouts",
    bonusUhrd: "Bonus UHRD",
    bonusGoals: "Beszerzési célok",
    bonusAwans: "ELŐLÉPTETÉSI BÓNUSZ",
    portalPromotions: "Promóciók",
    portalPromotionDetail: "Promóció részletei",
  },
  breadcrumbs: {
    dashboard: "Kezdőlap",
    accountDashboard: "Irányítópult",
    account: "Profilom",
    mailbox: "Bejövő üzenetek",
    singleMailbox: "Üzenetek",
    stammdaten: "PROFILOM",
    news_feeds: "Hír",
    pointsOverview: "Pontok áttekintése",
    rewardsOverview: "Pontok áttekintése",
    about: "A BS Plus-ról",
    service_number: "Kapcsolat szervizzel",
    shop: "Jutalombolt",
    salesPromotions: "Értékesítési promóciók",
    promotions: "Fiókom",
    shopCategory: "Jutalomáruház",
    productDetails: "Termék részletei",
    userOrders: "Felhasználói rendelések",
    shoppingCart: "Bevásárlókosár",
    orderDelivery: "Szállítási cím",
    orderSummary: "Rendelés áttekintése",
    orderComplete: "Rendelés befejezve",
    staff: "Szerviz irányítópult",
    onlineTrainings: "Online képzések",
    trainings: "Képzések",
    training: "Képzés",
    trainingForm: "Képzési űrlap",
    staffVouchers: "Utalványok",
    wholesalerVouchers: "Utalványok",
    brochure_prices: "Árlisták és brosúrák",
    investment: "Beruhazasi tamogatas",
    media: "Média",
    medias: "Média",
    contact_service: "Kapcsolat és szolgáltatás",
    productInfo: "TERMÉKINFORMÁCIÓK",
    bDrive: "Termékképek",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Részvételi feltételek",
    first_stop: "Bridgestone gumiabroncs-garancia",
    payouts: "Payouts",
    portalPromotions: "Promóciók",
    portalPromotionDetail: "Promóció részletei",
  },
  menu: {
    account: "Profilom",
    plus: 'A Bridgestone <span class="text-danger">Plus</span> oldalról',
    salesSupport: "Értékesítési támogatás",
    mailbox: "Bejövő üzenetek",
    about: "A BS Plus-ról",
    trainingAndCourses: "Képzések és tanfolyamok",
    externalTraining: "Külső képzés",
    productInfo: "Termékinformáció",
    productBrochures: "Termékismertetők",
    priceLists: "Árlisták",
    price: "Ár",
    complaintForm: "Panaszbejelentő űrlap",
    sales_support: "Értékesítési támogatás",
    contact_service: "Kapcsolat és szolgáltatás",
    logOut: "Kijelentkezés",
    news: "Hírek",
    news_feeds: "Hír",
    service_number: "Kapcsolat szervizzel",
    salesPromotions: "Értékesítési promóciók",
    shop: "Bolt",
    onlineTrainings: "Online képzések",
    trainings: "Képzések",
    brochure_prices: "Árlisták és brosúrák",
    media: "Média",
    medias: "Média",
    stammdaten: "PROFILOM",
    preislisten: "Árlisták",
  },
  validation: {
    requiredField: "Kötelező mező",
  },
  sortBy: {
    default: "Rendezés",
    desc: "Rendezés: Legújabb",
    asc: "Rendezés: Legrégebbi",
    name: "Név",
    date: "Dátum",
    choiceBy: "Rendezés",
  },
  month: {
    1: "január",
    2: "február",
    3: "március",
    4: "április",
    5: "május",
    6: "június",
    7: "július",
    8: "augusztus",
    9: "szeptember",
    10: "október",
    11: "november",
    12: "december",
  },
};


export default {
  messages,
};
